import { render, staticRenderFns } from "./UpdateSubUser.vue?vue&type=template&id=441d2718&"
import script from "./UpdateSubUser.vue?vue&type=script&lang=js&"
export * from "./UpdateSubUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports